import { createAction } from "@reduxjs/toolkit";

/**
 * Action to reset all store-specific state when switching between stores.
 * This ensures data from the previous store doesn't persist in the UI.
 *
 * Store-specific slices should listen to this action in their extraReducers
 * to reset their state to initial values.
 */
export const resetStoreSpecificState = createAction("store/resetStoreSpecificState");

/**
 * Action to trigger a refresh of store-specific data.
 * Components can dispatch this action to re-fetch data for the current store.
 */
export const refreshStoreData = createAction("store/refreshStoreData");

/**
 * Multi-tenant store context actions
 * These actions integrate with the tenant reducer to track the current store context
 */
export const setTenantStore = createAction<{
  storeId: string;
  storeType: string;
}>("store/setTenantStore");

export const clearTenantStore = createAction("store/clearTenantStore");
